__turbopack_context__.v({
  "input": "QuizAddressAutocomplete-module__2MpbPa__input",
  "option": "QuizAddressAutocomplete-module__2MpbPa__option",
  "spinner": "QuizAddressAutocomplete-module__2MpbPa__spinner",
  "spinner-turn": "QuizAddressAutocomplete-module__2MpbPa__spinner-turn",
});
